import { initReactI18next } from 'react-i18next';
import en from './en.json';
import { i18n } from './i18n';
import uk from './uk.json';

/**
 * Локалізація за ключами (ADR-012): підписи метаданих приходять у визначеннях і не дублюються тут.
 * bindI18nStore 'added' перерендерює useTranslation, коли loadModule додає рядки пакета у namespace `module.<ключ>`.
 */
export function setupI18n(lang: string): typeof i18n {
  if (!i18n.isInitialized) {
    void i18n.use(initReactI18next).init({
      resources: { uk: { translation: uk }, en: { translation: en } },
      lng: lang,
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
      react: { bindI18n: 'languageChanged', bindI18nStore: 'added' },
    });
  }
  return i18n;
}
